import { VStack, Text } from "@chakra-ui/react";

export default function DropZoneText() {
  return (
    <VStack>
      <Text fontSize="12px" color="gray.500">
        The same document with the column headers should be uploaded.
      </Text>
      <Text fontSize="12px" color="gray.500">
        <Text as="span" fontWeight="semibold" mr="1">
          Note:
        </Text>
        The email field should have unique values
      </Text>
    </VStack>
  );
}
